enum OrganizationPageEnum {
  Projects = 'projects',
  Users = 'users',
}

export default OrganizationPageEnum
